// extracted by mini-css-extract-plugin
module.exports = {"container":"GasDivision_container__277gB","row":"GasDivision_row__1h8OJ","item":"GasDivision_item__2LTWR","arrow":"GasDivision_arrow__lVR9E"};